<template>
  <div id="calendar">
    <div class="weekdays">
      <div v-for="day in weekdays" :key="day" class="weekday">{{ day }}</div>
    </div>
    <div class="weeks">
      <div v-for="(week, weekIndex) in weeks" :key="weekIndex" class="week">
        <div class="days">
          <div
            v-for="(day, dayIndex) in week"
            :key="dayIndex"
            class="day-box"
            :class="getDayClass(day)"
            @click="dayClick(day, weekIndex)"
          >
            <span :class="getDayClass(day)" class="day">{{ moment(day).format("D") }}</span>
            <!-- 插槽 每个日期下面需要显示的东西 -->
            <div class="day-info">
              <slot name="day-info" :day="day" :infoIndex="weekIndex"></slot>
            </div>
          </div>
        </div>
        <!-- 放在每周下面都有一行插槽
        watch 了 当 activeDate 发生改变时, 会触发dayClick事件, 并将当前日期以及当前周传递给父组件
        然后父组件可以根据当前日期所在周的索引, 渲染出该周下面需要显示的内容-->
        <slot name="more-info" :infoIndex="weekIndex"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'SimpleCalendar',
  props: {
    year: {
      default: new Date().getFullYear() // 默认当前年份
    },
    month: {
      default: new Date().getMonth() + 1 // 默认当前月份
    }
  },
  data() {
    return {
      weekdays: ['日', '一', '二', '三', '四', '五', '六'],
      weeks: [],
      activeDate: null, // 默认的当天日期
      clickDate: null // 选中的日期
    }
  },
  created() {
    // 根据传递的年月获取该年月的所有周的日期
    this.getWeeksInMonth(this.year, this.month)
    // 默认选中今天的日期
    this.activeDate = moment().format('YYYY-MM-DD')
  },
  watch: {
    clickDate(val) {
      // 选中日期改变时触发
      if (this.getWeekOfMonth >= 0) {
        this.$emit('dayClick', val, this.getWeekOfMonth)
      }
    },
    year(val) {
      if (val) {
        this.getWeeksInMonth(val, this.month)
      }
    },
    month(val) {
      if (val) {
        this.getWeeksInMonth(this.year, val)
      }
    }
  },
  computed: {
    getWeekOfMonth() {
      // 获取当前日期所在周的索引
      return this.weeks.findIndex(week => week.includes(this.clickDate))
    }
  },
  methods: {
    moment,
    dayClick(day, weekIndex) {
      // 日期点击事件
      this.clickDate = day
      this.clickWeekIndex = weekIndex
    },
    getWeeksInMonth(year, month) {
      // 获取指定年月的所有周的日期
      const weeks = []
      let currentDate = moment([year, month - 1, 1])
      const startDayOfWeek = currentDate.day() // 获取当月第一天是周几

      // 如果不是周日开始，则添加上个月的部分日子
      if (startDayOfWeek !== 0) {
        currentDate.subtract(startDayOfWeek, 'days')
      }

      while (currentDate.month() === month - 1 || weeks.length * 7 < 35) {
        let week = []
        for (let i = 0; i < 7; i++) {
          week.push(currentDate.format('YYYY-MM-DD'))
          currentDate.add(1, 'days')
        }
        weeks.push(week)
      }
      this.weeks = weeks
    },
    getDayClass(day) {
      // 获取日期的样式
      let cls = ''
      if (this.activeDate === day) cls += 'active '
      if (moment(day).format('YYYYMM') < moment().format('YYYYMM')) {
        cls += 'other-month '
      }
      if (this.clickDate === day) cls += 'clickdate '
      return cls.trim()
    }
  }
}
</script>

<style scoped lang="less">
#calendar {
  padding: 0 5px;
  box-sizing: border-box;

  .weekdays {
    display: flex;

    .weekday {
      flex: 1;
      display: flex;
      justify-content: center;
      font-size: 13px;
      color: #8f9bb3;
      font-weight: bold;
    }
  }

  .weeks {
    .week {
      display: flex;
      flex-direction: column;
      margin-top: 4px;

      .days {
        display: flex;
        justify-content: space-between;

        .day-box {
          flex: 1;
          text-align: center;
          color: #222b45;
          font-weight: bold;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 0 2px;
          min-height: 106px;
          box-sizing: border-box;
          padding-top: 5px;

          &.clickdate {
            background: #F9F8F7;
          }

          &.other-month {
            .day-info {
              opacity: 0.5;
            }
          }

          & > .day {
            width: 35px;
            height: 35px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            font-size: 15px;
            cursor: pointer;
            user-select: none;
          }

          & > .day.clickdate {
            color: #eb1700;
          }

          & > .day.active {
            background: #EB1700;
            color: #fff;
          }

          & > .day.other-month {
            color: #8f9bb3;
            pointer-events: none;
            cursor: not-allowed;
          }

          .day-info {
            width: 100%;
            margin: 5px 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SimpleCalendar.vue